import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { CopilotSnackbarComponent, CopilotSnackbarData } from './copilot-snackbar.component';

const DEFAULT_CONFIG: MatSnackBarConfig = {
  duration: 3000,
  horizontalPosition: 'end',
  verticalPosition: 'bottom',
  panelClass: ['copilot-snackbar-panel'],
};

export function openCopilotSnackbar(
  snackBar: MatSnackBar,
  message: string,
  config?: MatSnackBarConfig
): MatSnackBarRef<CopilotSnackbarComponent> {
  const extraPanelClasses = config?.panelClass
    ? Array.isArray(config.panelClass)
      ? config.panelClass
      : [config.panelClass]
    : [];

  return snackBar.openFromComponent(CopilotSnackbarComponent, {
    ...DEFAULT_CONFIG,
    ...config,
    data: { message } satisfies CopilotSnackbarData,
    panelClass: ['copilot-snackbar-panel', ...extraPanelClasses],
  });
}
